export const PASSWORD_RULES = {
  length: {
    test: (password: string) => password.length >= 8,
    label: 'Minimum 8 characters.',
  },
  lettersAndNumber: {
    test: (password: string) => /[A-Z]/.test(password) && /[a-z]/.test(password) && /[0-9]/.test(password),
    label: 'At least 1 uppercase, 1 lowercase, and 1 number.',
  },
  specialChar: {
    test: (password: string) => /[^a-zA-Z0-9]/.test(password),
    label: 'At least 1 special character.',
  },
};

export const isPasswordValid = (password: string): boolean =>
  PASSWORD_RULES.length.test(password) && PASSWORD_RULES.lettersAndNumber.test(password) && PASSWORD_RULES.specialChar.test(password);

export const PASSWORD_RULES_ATTRIBUTE =
  'minlength: 8; required: lower; required: upper; required: digit; required: [!"#$%&\'()*+,.:;<=>?@[^_`{|}~];';
